"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationTypes = exports.notificationTriggerTypes = exports.notificationStatuses = void 0;
exports.notificationStatuses = ['CREATED', 'SENT', 'FAILED', 'DELIVERED'];
exports.notificationTriggerTypes = ['AUTOMATED', 'MANUAL'];
exports.notificationTypes = [
    'MICROTASK_ASSIGNED',
    'AVATAR_LINKED',
    'REJECTED_ASSIGNMENTS',
    'TEST_TASK_PASSED',
    'TEST_TASK_FAILED',
    'MT_REASSIGNMENT',
    'MTA_VERIFICATION',
    'VOIP_INCOMING_CALL',
    'VOIP_REJECT_CALL',
    'WORKER_ID_ASSIGNED',
    'UNSPECIFIED',
];
//# sourceMappingURL=Notifications.js.map